import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { API_BASE } from "../config";
import "../styles/homePage.css";
import apiFetch from "../apiFetch";
import UserSettingsModal from "./UserSettingsModal";

export default function PageHeader({ pageTitle, pageSubtitle, headerActions }) {
  const navigate = useNavigate();
  const username = localStorage.getItem("displayName") || localStorage.getItem("username") || "Guest";
  const userId = localStorage.getItem("userId");
  const [level, setLevel] = useState(1);
  const [showSettings, setShowSettings] = useState(false);

  useEffect(() => {
    if (!userId) return;
    apiFetch(`/api/resources/xp/${userId}`)
      .then((r) => r.json())
      .then((d) => {
        if (typeof d.level === "number") setLevel(d.level);
      })
      .catch(() => {});
  }, [userId]);

  useEffect(() => {
    document.body.classList.add("has-page-header");
    return () => document.body.classList.remove("has-page-header");
  }, []);

  return (
    <header className="header page-header">
      <div className="header-left">
        <div
          className="logo"
          style={{ cursor: "pointer" }}
          onClick={() => navigate("/home")}
        >
          <img
            src={`${process.env.PUBLIC_URL}/images/owlletLogo.png`}
            alt="Owllet"
            style={{ width: "96px", height: "96px", objectFit: "contain" }}
          />
        </div>
        <div>
          <h1 className="title">Owllet Reading Quest</h1>
          <p className="subtitle">Master comprehension through adventure</p>
        </div>
      </div>

      {pageTitle && (
        <div className="page-header-title">
          <h2 className="page-header-h2">{pageTitle}</h2>
          {pageSubtitle && <p className="page-header-sub">{pageSubtitle}</p>}
        </div>
      )}

      <div className="header-right">
        {headerActions && (
          <div className="page-header-actions">{headerActions}</div>
        )}
        <div
          className="profile profile-card-link"
          onClick={() => setShowSettings(true)}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => e.key === "Enter" && setShowSettings(true)}
          aria-label="Open preferences"
        >
          <img
            src={`${process.env.PUBLIC_URL}/images/owlTestImgNoBG.png`}
            className="stat-card-img"
            alt="Profile"
          />
          <p className="profile-name">{username}</p>
        </div>
        <UserSettingsModal open={showSettings} onOpenChange={setShowSettings} />
      </div>
    </header>
  );
}
